import { Component, OnDestroy, OnInit } from '@angular/core';
import { ClinicInterface } from '../../../shared/models/clinic.interface';
import { filter, Subscription, switchMap, tap } from 'rxjs';
import { AppStateService } from '../../../shared/services/app-state.service';
import { AdminClinicService, PaymentMethod } from '../../../components/clinics/services/admin-clinic.service';
import { environment } from '../../../../environments/environment';
import { ModalDialogService } from '../../../shared/components/modal-dialog/modal-dialog.service';
import { SccPaymentProcessInfoComponent, SCC_PAYMENT_PROCESS_INFO_DIALOG_PARAMS } from './scc-payment-process-info/scc-payment-process-info.component';

@Component({
  selector: 'app-scc-payment-method-page',
  templateUrl: './scc-payment-method-page.component.html',
  styleUrls: ['./scc-payment-method-page.component.scss']
})
export class SccPaymentMethodPageComponent implements OnInit, OnDestroy {

  clinic?: ClinicInterface;
  paymentMethod?: PaymentMethod;
  nextInvoiceAmount?: number;

  private readonly subscription = new Subscription();

  constructor(
    private readonly appStateService: AppStateService,
    private readonly adminClinicService: AdminClinicService,
    private readonly paymentProcessInfoDialogService: ModalDialogService<boolean, undefined>
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.appStateService.clinicObservable
        .pipe(
          filter(clinic => !!clinic),
          switchMap(clinic => {
            this.clinic = clinic;
            return this.adminClinicService.getStripePaymentMethodForClinic(clinic?.id ?? 0)
              .pipe(
                tap(paymentMethod => this.paymentMethod = paymentMethod),
                switchMap(_ => this.adminClinicService.getAmountFuturInvoiceForClinic(clinic?.id ?? 0)),
                tap(nextInvoiceAmount => this.nextInvoiceAmount = nextInvoiceAmount),
              );
          })
        ).subscribe()
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  openStripe(): void {
    if (!this.paymentMethod?.stripeCustomerId) {
      return;
    }

    window.open(`${environment.apiUrl}/stripe/account/${this.paymentMethod?.stripeCustomerId}`, '_blank');
  }

  openPaymentProcessInfo(): void {
    this.subscription.add(
      this.paymentProcessInfoDialogService.openDialog(SCC_PAYMENT_PROCESS_INFO_DIALOG_PARAMS, SccPaymentProcessInfoComponent).subscribe()
    );
  }
}
